module.exports =

  uuid:   (state) -> state.uuid
  words:   (state) -> state.words
  wordOpts:   (state) -> state.wordOpts
  votes:  (state) -> state.votes
  user:        (state) -> state.user
  layout:      (state) -> state.layout
  layoutBackground:      (state) -> state.layoutBackground
  uuid:        (state) -> state.uuid
  apiUrl:      (state) -> state.apiUrl
  voices:      (state) -> state.voices
  display:     (state) -> state.display
  filters:     (state) -> state.filters
  sentences:   (state) -> state.sentences
  currentWord:   (state) -> state.currentWord
  currentSentence:   (state) -> state.currentSentence
  sentencePlayerRev: (state) -> state.sentencePlayerRev
  videoSeen: (state) -> state.videoSeen






// WEBPACK FOOTER //
// ./src/store/getters.coffee